export const mergeQuestionAndStats = (question, stats) => {
    return {
        id: question.id,
        title: question.text,
        percentage: Math.floor((stats === null || stats === void 0 ? void 0 : stats.average_percentage_score) || 0),
    };
};
